import * as React from "react";
import { forwardRef } from "react";
const SvgArrowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 6L8 10L4 6", stroke: "#727272", strokeWidth: 1.2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgArrowIcon);
export { ForwardRef as ReactComponent };
